import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CreatableSelect from 'react-select/lib/Creatable';
import api from "../../../api";

class SurveyTags extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      tagList: [],
      value: props.value || [],
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      loading: true
    });

    const apiCall = this.props.isUser ? api.tag.get.userTags() :  api.tag.get.tags()
     apiCall.then(tags => {
      this.setState({
        tagList: tags,
        loading: false,
      })
    })
  }

  onChange(options){
    const value = options.map(o => o.value);

    this.setState({
      value,
    });
    this.props.onChange(value);
  }

  render() {
    const {loading, value, tagList} = this.state;

    return (
      <CreatableSelect
        className="react-select"
        isMulti
        placeholder="Wybierz tagi"
        isLoading={loading}
        value={value.map(tag => {
          let t = tagList.find(t => t.name === tag);

          if(!t){
            return {
              label: <span>{tag}</span>,
              value: tag,
            }
          }

          return {
            label: <span>{t.name} ({t.surveysCount})</span>,
            value: t.name
          }

        })}
        onInputChange={value => value.replace(/[^a-zA-Z0-9\s+]+/gi, '').replace(/\s\s+/g, ' ')}
        onChange={e => { this.onChange(e) }}
        options={tagList.map(tag => {
          return {
            label: <span>{tag.name} ({tag.surveysCount})</span>,
            value: tag.name
          }
        })}
      />
    );
  }
}

SurveyTags.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string,),
  onChange: PropTypes.func.isRequired,
  isUser: PropTypes.bool
};

export default SurveyTags;